import { render, staticRenderFns } from "./OrticTimepicker.vue?vue&type=template&id=2908fc72"
import script from "./OrticTimepicker.vue?vue&type=script&lang=js"
export * from "./OrticTimepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports